export type CheckboxType = {
  label: string;
  type: string;
};

export const CheckboxTypes: CheckboxType[] = [
  {
    label: "Cgu",
    type: "CGU"
  },
  {
    label: "Données valides",
    type: "ValidData"
  },
  {
    label: "Newsletter",
    type: "Newsletter"
  }
];

export function getCheckboxType(type: string): CheckboxType | undefined {
  return CheckboxTypes.find(ft => ft.type === type);
}
